import { NgModule } from '@angular/core';

import { CmsAddToCartComponent, provideConfig } from '@spartacus/core';
import { CmsComponentData, ProductListComponentService } from '@spartacus/storefront';
import { of } from 'rxjs';

import { DpProductFacetNavigationModule } from './product-facet-navigation';
import { facetListPanelConfig } from '@app-modules/product/product-facet-navigation/facet-list-panel/facet-list-panel.config';
import { DpProductListComponentService } from '@app-modules/product/product-list/services';

import { DpProductRelatedPartsStoreModule } from './shared/store/product-related-parts';

@NgModule({
  imports: [DpProductRelatedPartsStoreModule, DpProductFacetNavigationModule],
  providers: [
    { provide: ProductListComponentService, useClass: DpProductListComponentService },
    {
      provide: CmsComponentData<CmsAddToCartComponent>,
      useValue: { data$: of({ inventoryDisplay: false } as CmsAddToCartComponent) }
    },
    provideConfig(facetListPanelConfig),
    provideConfig({
      featureModules: {
        productDetailsFeature: {
          cmsComponents: ['ProductFeatureComponent'],
          module: () => import('./product-features').then((m) => m.DpProductFeaturesModule)
        },
        productImagesFeature: {
          cmsComponents: ['ProductImagesComponent'],
          module: () => import('./product-images').then((m) => m.DpProductImagesModule)
        },
        productCmsCarouselsFeature: {
          cmsComponents: ['ProductCarouselComponent'],
          module: () => import('./product-carousel').then((m) => m.DpProductCmsCarouselModule)
        },
        productIntroFeature: {
          cmsComponents: ['ProductIntroComponent'],
          module: () => import('./product-intro').then((m) => m.DpProductIntroModule)
        },
        productSummaryFeature: {
          cmsComponents: ['ProductSummaryComponent'],
          module: () => import('./product-summary').then((m) => m.DpProductSummaryModule)
        },
        productSubcategoriesFeature: {
          cmsComponents: ['HomepageProductSubcategoriesComponent', 'ProductListSubcategoriesComponent'],
          module: () => import('./product-subcategories').then((m) => m.DpProductSubcategoriesModule)
        },
        productListModule: {
          cmsComponents: ['SearchResultsListComponent', 'CMSProductListComponent'],
          module: () => import('./product-list').then((m) => m.DpProductListModule)
        },
        productAddToCartModule: {
          cmsComponents: ['ProductAddToCartComponent'],
          module: () => import('./product-details-add-to-cart').then((m) => m.DpProductDetailsAddToCartModule)
        }
      }
    })
  ]
})
export class DpProductFeatureModule {}
